<template>
    <div>
        <div
            class="fixed top-0 left-0 w-full h-full bg-brand-neutral-7/50 z-[200]"
            @click="$emit('close')"
        ></div>
        <div
            class="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full md:w-96 px-4 z-[201]"
        >
            <div class="bg-white rounded-xl shadow-md">
                <div
                    class="px-4 py-3 border border-brand-neutral-3 flex justify-between items-center w-full rounded-t-xl"
                >
                    <p class="text-brand-neutral-7 font-bold text-xl">
                        Deletar
                    </p>
                    <Button
                        @click="$emit('close')"
                        class="w-12 h-12 rounded-full"
                        variant="tertiary"
                    >
                        <span class="fi fi-br-cross-small text-2xl flex"></span>
                    </Button>
                </div>
                <div class="px-4 py-6">
                    <h1 class="text-brand-neutral-6 font-bold text-base mb-6">
                        Tem certeza que deseja deletar?
                    </h1>
                    <NuxtImg
                        class="w-132 h-24 object-cover rounded-xl border rand-neutral-3 mb-4 mx-auto shrink-0"
                        :src="image"
                        :alt="title"
                    />
                    <p class="text-brand-neutral-6/95 text-sm mb-6 text-center">
                        {{ title }}
                    </p>
                    <Button
                        class="mb-4"
                        @click="$emit('delete')"
                        variant="danger"
                        >Deletar</Button
                    >
                    <Button @click="$emit('close')" variant="outline"
                        >Cancelar</Button
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
const { image, title } = defineProps<{
    image: string;
    title: string;
}>();

onMounted(() => {
    document.body.style.overflow = "hidden";
});

onUnmounted(() => {
    document.body.style.overflow = "auto";
});
</script>
